import React from 'react';

import DatePill from './DatePill';

import { startOfDay } from 'date-fns';
import { groupBy } from 'lodash';
import { ISubject } from '../../lib/helpers/types';
import TimelineContainer from './TimelineContainer';
import TimelineEntry from './TimelineEntry';

export interface Note {
  id: string;
  composedBy: {
    id: string;
    displayName: string;
    user: {
      avatarUrl: string | null | undefined;
    };
  };
  subjects: ISubject[];
  measurements: {
    subject: {
      id: string;
    };
    tracker: {
      id: string;
    };
    value: number;
  }[];
  notedAt: Date;
  context: string | null;
  content: string | null;
}

interface TimelineProps {
  notes: Note[];
}

const Timeline: React.FunctionComponent<TimelineProps> = ({ notes }) => {
  const notesByDate = groupBy(notes, note => startOfDay(note.notedAt));

  return (
    <TimelineContainer>
      {Object.keys(notesByDate).map((day: string) => (
        <div key={day}>
          <DatePill date={new Date(day)} />
          {notesByDate[day].map(note => (
            <TimelineEntry key={note.id} note={note} />
          ))}
          <div className="w2 bb b--navy center mb1" />
        </div>
      ))}
      <p className="f8 light-silver tc mt3 mb5">This is the beginning of your feed.</p>
    </TimelineContainer>
  );
};

export default Timeline;
